import * as PropTypes from 'prop-types'
import * as React from 'react'
import { Avatar, AvatarStyle, OptionContext } from 'avataaars'
import { OptionState } from 'avataaars/src/options/OptionContext'
import {} from 'avataaars/src/options'

interface Props {}

interface State {}

class OptionContextDecorator {
  private _target: OptionContext
  private _valueOverride: { [index: string]: string }

  constructor(
    target: OptionContext,
    valueOverride: { [index: string]: string }
  ) {
    this._target = target
    this._valueOverride = valueOverride
  }

  get options() {
    return this._target.options
  }

  get state() {
    return this._target.state
  }

  addStateChangeListener(listener: () => void) {
    this._target.addStateChangeListener(listener)
  }

  removeStateChangeListener(listener: () => void) {
    this._target.removeStateChangeListener(listener)
  }

  addValueChangeListener(listener: (key: string, value: string) => void) {
    this._target.addValueChangeListener(listener)
  }

  removeValueChangeListener(listener: (key: string, value: string) => void) {
    this._target.removeValueChangeListener(listener)
  }

  optionEnter(key: string) {
    this._target.optionEnter(key)
  }

  optionExit(key: string) {
    this._target.optionExit(key)
  }

  getOptionState(key: string): OptionState | null {
    return this._target.getOptionState(key)
  }

  getValue(key: string): string | null {
    if (key in this._valueOverride) {
      return this._valueOverride[key]
    }
    return this._target.getValue(key)
  }

  setValue(key: string, value: string) {
    this._target.setValue(key, value)
  }

  // set single source of truth
  setData(data: { [index: string]: string }) {
    this._target.setData(data)
  }

  setDefaultValue(key: string, defaultValue: string) {
    this._target.setDefaultValue(key, defaultValue)
  }

  setOptions(key: string, options: Array<string>) {
    this._target.setOptions(key, options)
  }
}

export default class Sponsor extends React.Component<Props, State> {
  static contextTypes = {
    optionContext: PropTypes.instanceOf(OptionContext),
  }
  static childContextTypes = {
    optionContext: PropTypes.instanceOf(OptionContext),
  }
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  getChildContext() {
    const _ = new OptionContextDecorator(this.context.optionContext, {})
    console.log(_)
    return {
      // optionContext: new OptionContextDecorator(this.context.optionContext, {})
      optionContext: this.context.optionContext,
    }
  }

  render() {
    return (
      <div>
        <h4>
          Sponsor - Video virtual backgrounds for zoom meetings{' '}
          <span className='badge badge-warning badge-secondary'>New</span>
        </h4>
        <div
          style={{
            textAlign: 'center',
            height: '261px',
            position: 'relative',
          }}>
          <Avatar
            avatarStyle={AvatarStyle.Transparent}
            style={{
              height: '160px',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          />
          <video
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              height: '261px',
              marginLeft: 'auto',
              marginRight: 'auto',
              zIndex: -1,
            }}
            playsInline
            preload='auto'
            autoPlay
            muted
            loop
            data-setup='{ "bigPlayButton": false }'
            poster='https://livelybg-upload-prod.s3.us-west-2.amazonaws.com/videos/652e446c-92fa-4a8e-a013-c1bc463d7ac5/thumbnail.jpg'
            tabIndex={-1}
            role='application'>
            <source
              src='https://livelybg-upload-prod.s3.us-west-2.amazonaws.com/videos/652e446c-92fa-4a8e-a013-c1bc463d7ac5/thumbnail.hevc.mp4'
              type='video/mp4; codecs=hevc'
            />
            <source
              src='https://livelybg-upload-prod.s3.us-west-2.amazonaws.com/videos/652e446c-92fa-4a8e-a013-c1bc463d7ac5/thumbnail.webm'
              type='video/ogg; codecs=vp9'
            />
            <source
              src='https://livelybg-upload-prod.s3.us-west-2.amazonaws.com/videos/652e446c-92fa-4a8e-a013-c1bc463d7ac5/thumbnail.mp4'
              type='video/mp4'
            />
          </video>
        </div>

        <p className='mt-3'>
          Tried of boring Zoom virtual background? Want to have good
          conversation starters in virtual meetings? Find and share your
          favorite video virtual background at{' '}
          <a href='https://livelybg.com' target='_blank'>
            LIVELYBG.com
          </a>{' '}
          now!
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sponsor.tsx